import CohealerCourseCalendar from './CohealerCourseCalendar';

export default CohealerCourseCalendar;
